import React, { Component } from "react";

class UserDelete extends Component {
  render() {
    return (
      <div>
        <h1>User Delete</h1>
      </div>
    );
  }
}

export default UserDelete;
